import * as ACTION from '../constants';

const INITIAL_STATE = {
  error: null,
  loading: false,
  data: {},
};

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case ACTION.INTERVIEW_REQUEST:
    case ACTION.INTERVIEW_CONFIRM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ACTION.INTERVIEW_SUCCESS:
    case ACTION.INTERVIEW_CONFIRM_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data || {},
        error: null,
      };
    case ACTION.INTERVIEW_FAILURE:
    case ACTION.INTERVIEW_CONFIRM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
